.minute-options {
  min-width: 180px;
}
